import React from 'react';
import { Space, Typography, Flex } from 'antd';

const EventPayload = ({ payload }) => {
  const { Text } = Typography;

  if (!payload) return null;

  const filterKeys = ['value', 'currency'];

  if (typeof payload === 'string') {
    return <Text keyboard>payload</Text>;
  }

  if (typeof payload === 'object') {
    return (
      <div direction='vertical' className='space-y-1 w-full' size={0}>
        {Object.keys(payload)
          .filter((f) => !filterKeys.includes(f))
          .map((key) => {
            const label = key.replace(/_/g, ' ').replace(/^\w/, (c) => c.toUpperCase());
            return (
              <Flex align='center' gap='small' key={key} justify='space-between'>
                <Text className='text-xs font-medium'>{label}: </Text>
                <Text code className='text-sm font-semibold'>
                  {payload[key]}
                </Text>
              </Flex>
            );
          })}
      </div>
    );
  }

  return null;
};

export default EventPayload;
